import React, { Component } from "react";
import CustomButton from "../components/CustomButton";
// import UserGroupItem from '../components/UserGroupItem'
import Cancel from "../assets/cancel.svg";
import Tick from "../assets/tick.svg";
// import {Form} from 'react-bootstrap'
// import { WhisperSpinner  } from "react-spinners-kit"
// import circletick from "../assets/circletick.svg";
import { Icon } from "@iconify/react";
import circleTick from "@iconify/icons-charm/circle-tick";

export default class QuestionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: this.props.list,
    };

    this.updateList = this.updateList.bind(this);
  }

  componentDidMount() {
    this.updateList();
  }

  componentDidUpdate(prevProps) {
    if (this.props.list !== prevProps.list) {
      this.updateList();
    }
  }

  updateList() {
    let list = this.props.list;
    console.log(this.props.currentSelected);
    list.forEach((element) => {
      element.selected = false;
    });
    list.forEach((element) => {
      this.props.currentSelected.forEach((element1) => {
        if (element.id === element1) element.selected = true;
      });
    });

    this.setState({ list: list });
  }

  onConfirm() {
    let list = [];
    this.state.list.forEach((element) => {
      if (element.selected) list.push(element.id);
    });
    this.props.onConfirmQuestions(list);
  }

  hideModal() {
    this.props.hideModal();
  }

  iSelected(id) {
    let list = JSON.parse(JSON.stringify(this.state.list));
    list.forEach((element) => {
      if (element.id === id) {
        if (element.selected) element.selected = false;
        else element.selected = true;
      }
    });

    this.setState({ list: list });
  }

  render() {
    return (
      <div className="listViewer">
        {!this.props.loading && (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              // alignItems: "center",
              maxHeight: "400px",
            }}
          >
            {this.state.list.map((item, i) => {
              // return <UserGroupItem key={i} index={i} notShowIcon id={item.id} selected={item.selected} name={item.name} onSelected={this.iSelected.bind(this,item.id)} />
              return (
                <div
                  key={i}
                  className="UGItem"
                  // style={{ width: "100" }}
                  onClick={this.iSelected.bind(this, item.id)}
                >
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{
                          fontFamily: "SFUIDisplayBold",
                          fontSize: "14px",
                        }}
                      >
                        {item.name}
                      </div>
                      <div
                        style={{
                          fontFamily: "SFUIDisplay",
                          fontSize: "14px",
                          marginTop: "4px",
                        }}
                      >
                        {item.text}
                      </div>
                    </div>
                  </div>

                  {/* <img
                    src={circletick}
                    alt=""
                    style={{
                      height: "20px",
                      margin: "0px 5px",
                      objectFit: "contain",
                      visibility: item.selected ? "visible" : "hidden",
                    }}
                  /> */}
                  {item.selected && (
                    <Icon
                      icon={circleTick}
                      color={"var(--black1)"}
                      width="18"
                      height="18"
                    />
                  )}
                </div>
              );
            })}
          </div>
        )}

        <div
          style={{
            width: "100%",
            maxWidth: "500px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "20px",
            alignItems: "center",
          }}
        >
          <div style={{ flex: "1" }}>
            <CustomButton
              title="تایید"
              imgHeight={20}
              imgWidth={25}
              minHeight="35px"
              img={Tick}
              onClick={this.onConfirm.bind(this)}
            />
          </div>
          <div style={{ minWidth: "10px" }} />
          <div style={{ flex: "0.8" }}>
            <CustomButton
              title="انصراف"
              imgHeight={19}
              backColor="var(--black1)"
              imgWidth={25}
              minHeight="35px"
              img={Cancel}
              onClick={this.hideModal.bind(this)}
            />
          </div>
        </div>

        {/* <div style={{display:'flex',width:'100%',height:'100%',minHeight:'200px',justifyContent:'center',alignItems:'center'}}><WhisperSpinner size={30} color="var(--brown1)" frontColor="var(--brown1)" backColor="var(--brown1)" loading={true} /></div> */}
      </div>
    );
  }
}
